import { Injectable, Inject, Renderer2, RendererFactory2 } from '@angular/core';
import { DOCUMENT } from "@angular/common";
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';
import { LanguageService } from '../services/language.service';
declare var $: any;
declare var navigator:any;

@Injectable({
    providedIn: 'root'
})
export class CommonHelper {
    public _renderer2 : Renderer2
    public prevUrl = '';
    public currentUrl = '';
    constructor(
        @Inject(DOCUMENT) private _document: Document,
        private rendererFactory: RendererFactory2,
        private router: Router, 
        private languageService: LanguageService
    ) { 
        this._renderer2 = this.rendererFactory.createRenderer(null, null);
    }

    public static getTimeAmPm(date: Date){
        let hours = date.getHours();
        let minutes = date.getMinutes();
        let ampm = hours >= 12 ? 'pm' : 'am';
        hours = hours % 12;
        hours = hours ? hours : 12; // the hour '0' should be '12'
        let nminutes = minutes < 10 ? '0'+minutes : minutes;
        var strTime = hours + ':' + nminutes + ' ' + ampm;
        return strTime;
    }
    
    public static getDate(date: string): Date {
        const a = date.replace(' ', 'T').split(/[^0-9]/);
        const d = new Date();
        if (typeof a[0] !== 'undefined')
            d.setFullYear(parseInt(a[0]));
        if (typeof a[1] !== 'undefined')
            d.setMonth(parseInt(a[1]) - 1);
        if (typeof a[2] !== 'undefined')
            d.setDate(parseInt(a[2]));
        if (typeof a[3] !== 'undefined')
            d.setHours(parseInt(a[3]));
        if (typeof a[4] !== 'undefined')
            d.setMinutes(parseInt(a[4]));
        if (typeof a[5] !== 'undefined')
            d.setSeconds(parseInt(a[5]));
        return d;
    }

    public get isMobile(){
        var windowsize = $(window).width();
        return windowsize <= 767;
    }

    public static replaceMonthToNumber(date: string){
        const months = ['Enero','Febrero','Marzo','Abril','Mayo','Junio','Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre'];
        for(const i in months){
            date = date.replace(months[i], (parseInt(i) + 1).toString());
        }
        return date;
    }

    public doLogin(user, auth, userHelper, router){
        Swal.fire({
        allowOutsideClick: false,
        type: 'info',
        text: this.getTranslation('errors.pleaseWait')
        });
        Swal.showLoading();
    
        auth.login(user).subscribe((request) => {
            Swal.close();
            $(".mfp-close").click();
            const loggedUser = userHelper.getUser();
            if (this.prevUrl.indexOf('checkout') !== -1 && loggedUser.hasOneValidMembership) {
                this.prevUrl = '/profile';
            }
            if (this.prevUrl != '') {
                router.navigateByUrl(this.prevUrl);
            }
            if (this.prevUrl == '') {
                window.location.href = '/home';
            }
            this.prevUrl = '';
            }, (err) => {
            Swal.close();
        
            var message = "";
            switch (err.status) {
                case 400:
                message = this.getTranslation('errors.emailPasswordIncorrect');
                break;
                case 401:
                message = this.getTranslation('errors.emailPasswordIncorrect');
                break;
                case 404:
                message = this.getTranslation('errors.emailPasswordIncorrect');
                break;
                default:
                message = this.getTranslation('errors.serverError');
                break;
            }
            Swal.fire({
                type: 'error',
                text: message
            });
        });
    }

    public openPage(url: string, data: any = {}){
        this.router.navigateByUrl(url, data);
    }

    public get isEnabledCookiesPtl(){
        const ptl = localStorage.getItem('cookies-ptl');
        return typeof ptl === 'undefined' || ptl === null ? true : false;
    }

    public disableCookiesPtl(){
        localStorage.setItem('cookies-ptl', '1');
    }

    public setLanguage(lng: string){
        let found = false;
        for(let i in environment.language){
            if(environment.language[i] === lng && !found){
                found = true;
                localStorage.setItem('lang',lng.toLocaleLowerCase());
            }
        }
        if(!found){
            localStorage.setItem('lang', 'es');
        }
    }

    public isValidLanguage(lng: string){
        for(let i in environment.language){
            if(environment.language[i] === lng){
                return true;
            }
        }
        return false;
    }

    public static get storeLanguage(): string{
        let lng = localStorage.getItem('lang');
        if(typeof lng !== 'undefined' && lng !== null && lng !== ''){
            for(let i in environment.language){
                if(environment.language[i] === lng){
                    return environment.language[i];
                }
            }
        }
        return environment.language[0];
    }

    public static get requestLanguage(): string{
        return LanguageService.getRequestLanguage(this.storeLanguage);
    }
    
    public getTranslation(text: string){
        let lng = CommonHelper.storeLanguage;
        let languages = this.languageService.getLanguage(lng);
        const positions = text.split('.');
        if(positions.length > 1){
            let i2 = 0;
            let cPos = positions[i2];
            let cObj = languages;
            while(cPos !== ''){
                cObj = cObj && typeof cObj[cPos] !== 'undefined' && cObj[cPos] !== null ? cObj[cPos] : false;
                if(cObj && (i2 + 1) === positions.length)
                    return cObj;
                else if(cObj){
                    cPos = positions[++i2];
                } else {
                    return '';
                }
            }
            return '';
        }
        else {
            for(let i in languages){
                if(i === text){
                    return languages[i];
                }
            }
        }
        return text;
    }


    public async addScriptLink(link: string){
        let node = document.createElement('script'); // creates the script tag
        node.src = link; // sets the source (insert url in between quotes)
        node.type = 'text/javascript'; // set the script type
        node.async = false; // makes script run asynchronously
        node.charset = 'utf-8';
        // append to head of document
        return document.getElementsByTagName('head')[0].appendChild(node); 
    }

    public detectBrowserName() { 
        const agent = window.navigator.userAgent.toLowerCase()
        switch (true) {
          case agent.indexOf('edge') > -1:
            return 'edge';
          case agent.indexOf('opr') > -1 && !!(<any>window).opr:
            return 'opera';
          case agent.indexOf('chrome') > -1 && !!(<any>window).chrome:
            return 'chrome';
          case agent.indexOf('trident') > -1:
            return 'ie';
          case agent.indexOf('firefox') > -1:
            return 'firefox';
          case agent.indexOf('safari') > -1:
            return 'safari';
          default:
            return 'other';
        }
    }

    public getMobileOperatingSystem(){
        if (/windows/i.test(navigator.userAgent)) {
            return 2
        }
        else if (/iphone/i.test(navigator.userAgent)) {
            return 1
        }
        else if (/ipad/i.test(navigator.userAgent)) {
            return 1
        }
        else if (/macintosh/i.test(navigator.userAgent)) {
            return 1
        }
        return 2;
    }

}
